import { useDepartureDateFilter } from '@/scopes/search/components/DepartureDateFilter/hooks'
import { FilterSummary } from '@/scopes/search/components/QuickSearchBar/FilterSummary'
import { useMultiSelectFilter } from '@/scopes/search/search/domain/hooks'
import * as React from 'react'

export function DepartureDateFilterSummary() {
  const { options } = useMultiSelectFilter('DepartureDate')
  const { formattedText } = useDepartureDateFilter({ options })

  return <FilterSummary icon="Calendar" texts={formattedText} />
}
